/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

document.addEventListener('DOMContentLoaded', function() {
  const checkbox = document.getElementById('gift-message-checkbox');
  const inputContainer = document.getElementById('gift-message-input');
  const textArea = document.getElementById('gift-message-text');
  const wordCounter = document.getElementById('gift-message-counter');
  const saveButton = document.getElementById('gift-message-save');
  const hiddenInput = document.getElementById('gift-message-hidden');

  // Funktion zum Überprüfen, ob der Speichern-Button aktiviert werden soll
  function checkSaveButton() {
    const message = textArea.value.trim();
    saveButton.disabled = message === '';
    saveButton.classList.toggle('button--ternary', message === '');
    saveButton.classList.toggle('gift-message-save', message !== '');
  }

  checkbox.addEventListener('change', function() {
    inputContainer.style.display = this.checked ? 'block' : 'none';
    if (!this.checked) {
      textArea.value = '';
      hiddenInput.value = '';
      wordCounter.textContent = '0 / 30';
      saveButton.disabled = true;
    } else {
      checkSaveButton();
    }
  });

  textArea.addEventListener('input', function() {
    const words = this.value.trim().split(/\s+/);
    const wordCount = words[0] === '' ? 0 : words.length;
    wordCounter.textContent = wordCount + ' / 30';
    
    if (wordCount > 30) {
      this.value = words.slice(0, 30).join(' ');
      wordCounter.textContent = '30 / 30';
    }

    checkSaveButton();
  });

  saveButton.addEventListener('click', function() {
    const message = textArea.value.trim();
    if (message !== '') {
      hiddenInput.value = message;
      //alert('Die Geschenknachricht wurde gespeichert.');
    }
  });

  // Beim Laden der Seite den Speichern-Button deaktivieren
  saveButton.disabled = true;
});

function updateGiftContent(variant) {
  let giftContent = document.querySelector("[data-gift-content]");
  
  if (!giftContent || !variant) {
    return;
  }
  
  giftContent.innerHTML = "";
  
  if ((variant.id === 44680675459336) || (variant.id === 44698329678088) || (variant.id === 44698322469128)) {
	giftContent.innerHTML = `
		  <input id="inhalt1" type="hidden" name="properties[_inhalt1]" value="Nr. 24 Omas Lieblingsmischung (80g)">
		  <input id="inhalt2" type="hidden" name="properties[_inhalt2]" value="Nr. 32 Alpenwind (30g)">
		  <input id="inhalt3" type="hidden" name="properties[_inhalt3]" value="Nr. 9 Ayurveda Vata (70g)">
		  <input id="inhalt4" type="hidden" name="properties[_inhalt4]" value="Teewissen kompakt">
	`;
  // MIX ohne Flasche / Sieb: Weihnachten enthält Weihnachtsleckerei statt Omas Lieblingsmischung
  } else if (variant.id === 44698304413960) {
    giftContent.innerHTML = `
            <input id="inhalt1" type="hidden" name="properties[_inhalt1]" value="Nr. 8 Weihnachtsleckerei (70g)">
            <input id="inhalt2" type="hidden" name="properties[_inhalt2]" value="Nr. 32 Alpenwind (30g)">
            <input id="inhalt3" type="hidden" name="properties[_inhalt3]" value="Nr. 9 Ayurveda Vata (70g)">
            <input id="inhalt4" type="hidden" name="properties[_inhalt4]" value="Teewissen kompakt">
      `;
  //Früchtetee Ohne Flasche / Sieb: 39-himbeer-und-70g	24-omas-liebling-80g	40-valenciana-60g	Teewissen kompakt
  } else if ((variant.id === 44652332318984) || (variant.id === 44698304315656) || (variant.id === 44698329547016) || (variant.id === 44698322370824)) {
    giftContent.innerHTML = `
		  <input id="inhalt1" type="hidden" name="properties[_inhalt1]" value="Nr. 39 Himbeer & Mehr (70g)">
		  <input id="inhalt2" type="hidden" name="properties[_inhalt2]" value="Nr. 24 Omas Lieblingsmischung (80g)">
		  <input id="inhalt3" type="hidden" name="properties[_inhalt3]" value="Nr. 40 La Valenciana (60g)">
		  <input id="inhalt4" type="hidden" name="properties[_inhalt4]" value="Teewissen kompakt">
	`;
  //Kräutertee Ohne Flasche / Sieb: 32-alpenwind-30g	9-ayuverda-vata-70g	3-Aphroditee-60g	Teewissen kompakt
  } else if ((variant.id === 44680675295496) || (variant.id === 44698304348424) || (variant.id === 44698329579784) || (variant.id === 44698322403592)) {
    giftContent.innerHTML = `
		  <input id="inhalt1" type="hidden" name="properties[_inhalt1]" value="Nr. 32 Alpenwind (30g)">
		  <input id="inhalt2" type="hidden" name="properties[_inhalt2]" value="Nr. 9 Ayurveda Vata (70g)">
		  <input id="inhalt3" type="hidden" name="properties[_inhalt3]" value="Nr. 3 Aphroditee (60g)">
		  <input id="inhalt4" type="hidden" name="properties[_inhalt4]" value="Teewissen kompakt">
	`;
  //Grüntee Ohne Flasche / Sieb: 14-untouched-70g	30-holy-monk-50g	34-drachentee-50g	Teewissen kompakt
  } else if ((variant.id === 44680675361032) || (variant.id === 44698304381192) || (variant.id === 44698329612552) || (variant.id === 44698322436360)) {
    giftContent.innerHTML = `
		  <input id="inhalt1" type="hidden" name="properties[_inhalt1]" value="Nr. 14 Untouched Blossom (70g)">
		  <input id="inhalt2" type="hidden" name="properties[_inhalt2]" value="Nr. 30 Holy Monk (50g)">
		  <input id="inhalt3" type="hidden" name="properties[_inhalt3]" value="Nr. 34 Dragon Well (50g)">
		  <input id="inhalt4" type="hidden" name="properties[_inhalt4]" value="Teewissen kompakt">
	`;
  //Yoga Tee Ohne Flasche / Sieb: 1-ingwershot-70g	9-ayuverda-vata-70g	3-Aphroditee-60g	Teewissen kompakt
  } else if ((variant.id === 44698241990920) || (variant.id === 44698304446728) || (variant.id === 44698329710856) || (variant.id === 44698322501896)) {
    giftContent.innerHTML = `
		  <input id="inhalt1" type="hidden" name="properties[_inhalt1]" value="Nr. 1 Ingwer & Kurkuma (70g)">
		  <input id="inhalt2" type="hidden" name="properties[_inhalt2]" value="Nr. 9 Ayurveda Vata (70g)">
		  <input id="inhalt3" type="hidden" name="properties[_inhalt3]" value="Nr. 3 Aphroditee (60g)">
		  <input id="inhalt4" type="hidden" name="properties[_inhalt4]" value="Teewissen kompakt">
	`;
 /*
  * MIT TEE SIEB
  */
  // MIX mit Sieb: 24-omas-liebling-80g	32-alpenwind-30g	9-ayuverda-vata-70g	Teewissen kompakt
  } else if ((variant.id === 44680675590408) || (variant.id === 44698329841928) || (variant.id === 44698322665736)) {
    giftContent.innerHTML = `
		  <input id="inhalt1" type="hidden" name="properties[_inhalt1]" value="Nr. 24 Omas Lieblingsmischung (80g)">
		  <input id="inhalt2" type="hidden" name="properties[_inhalt2]" value="Nr. 32 Alpenwind (30g)">
		  <input id="inhalt3" type="hidden" name="properties[_inhalt3]" value="Nr. 9 Ayurveda Vata (70g)">
		  <input id="inhalt4" type="hidden" name="properties[_inhalt4]" value="Teewissen kompakt">
		  <input id="inhalt5" type="hidden" name="properties[_inhalt5]" value="Teesieb">
	`;
  
  //MIX mit Sieb: Weihnachten mit anderem Tee
  }else if (variant.id === 44698304610568) {
    giftContent.innerHTML = `
		  <input id="inhalt1" type="hidden" name="properties[_inhalt1]" value="Nr. 8 Weihnachtsleckerei (70g)">
		  <input id="inhalt2" type="hidden" name="properties[_inhalt2]" value="Nr. 32 Alpenwind (30g)">
		  <input id="inhalt3" type="hidden" name="properties[_inhalt3]" value="Nr. 9 Ayurveda Vata (70g)">
		  <input id="inhalt4" type="hidden" name="properties[_inhalt4]" value="Teewissen kompakt">
		  <input id="inhalt5" type="hidden" name="properties[_inhalt5]" value="Teesieb">
	`;

  //Früchtetee mit Sieb: 39-himbeer-und-70g	24-omas-liebling-80g	40-valenciana-60g	Teewissen kompakt
  } else if ((variant.id === 44652332351752) || (variant.id === 44698304479496) || (variant.id === 44698329743624) || (variant.id === 44698322534664)) {
    giftContent.innerHTML = `
		  <input id="inhalt1" type="hidden" name="properties[_inhalt1]" value="Nr. 39 Himbeer & Mehr (70g)">
		  <input id="inhalt2" type="hidden" name="properties[_inhalt2]" value="Nr. 24 Omas Lieblingsmischung (80g)">
		  <input id="inhalt3" type="hidden" name="properties[_inhalt3]" value="Nr. 40 La Valenciana (60g)">
		  <input id="inhalt4" type="hidden" name="properties[_inhalt4]" value="Teewissen kompakt">
		  <input id="inhalt5" type="hidden" name="properties[_inhalt5]" value="Teesieb">
	`;
  //Kräutertee mit Sieb: 32-alpenwind-30g	9-ayuverda-vata-70g	3-Aphroditee-60g	Teewissen kompakt
  } else if ((variant.id === 44680675524872) || (variant.id === 44698304512264) || (variant.id === 44698329776392) || (variant.id === 44698322567432)) {
    giftContent.innerHTML = `
		  <input id="inhalt1" type="hidden" name="properties[_inhalt1]" value="Nr. 32 Alpenwind (30g)">
		  <input id="inhalt2" type="hidden" name="properties[_inhalt2]" value="Nr. 9 Ayurveda Vata (70g)">
		  <input id="inhalt3" type="hidden" name="properties[_inhalt3]" value="Nr. 3 Aphroditee (60g)">
		  <input id="inhalt4" type="hidden" name="properties[_inhalt4]" value="Teewissen kompakt">
		  <input id="inhalt5" type="hidden" name="properties[_inhalt5]" value="Teesieb">
	`;
  //Grüntee mit Sieb: 14-untouched-70g	30-holy-monk-50g	34-drachentee-50g	Teewissen kompakt
  } else if ((variant.id === 44680675557640) || (variant.id === 44698304545032) || (variant.id === 44698329809160) || (variant.id === 44698322632968)) {
    giftContent.innerHTML = `
		  <input id="inhalt1" type="hidden" name="properties[_inhalt1]" value="Nr. 14 Untouched Blossom (70g)">
		  <input id="inhalt2" type="hidden" name="properties[_inhalt2]" value="Nr. 30 Holy Monk (50g)">
		  <input id="inhalt3" type="hidden" name="properties[_inhalt3]" value="Nr. 34 Dragon Well (50g)">
		  <input id="inhalt4" type="hidden" name="properties[_inhalt4]" value="Teewissen kompakt">
		  <input id="inhalt5" type="hidden" name="properties[_inhalt5]" value="Teesieb">
	`;
  //Yoga Tee mit Sieb: 1-ingwershot-70g	9-ayuverda-vata-70g	3-Aphroditee-60g	Teewissen kompakt
  } else if ((variant.id === 44698242023688) || (variant.id === 44698304643336) || (variant.id === 44698329874696) || (variant.id === 44698322698504)) {
    giftContent.innerHTML = `
		  <input id="inhalt1" type="hidden" name="properties[_inhalt1]" value="Nr. 1 Ingwer & Kurkuma (70g)">
		  <input id="inhalt2" type="hidden" name="properties[_inhalt2]" value="Nr. 9 Ayurveda Vata (70g)">
		  <input id="inhalt3" type="hidden" name="properties[_inhalt3]" value="Nr. 3 Aphroditee (60g)">
		  <input id="inhalt4" type="hidden" name="properties[_inhalt4]" value="Teewissen kompakt">
		  <input id="inhalt5" type="hidden" name="properties[_inhalt5]" value="Teesieb">
	`;

  /*
  * MIT TEEFLASCHE
  */
  // MIX mit Flasche: 24-omas-liebling-80g	32-alpenwind-30g	9-ayuverda-vata-70g	Teewissen kompakt
  } else if ((variant.id === 44680675688712) || (variant.id === 44698330005768) || (variant.id === 44698322829576)) {
    giftContent.innerHTML = `
		  <input id="inhalt1" type="hidden" name="properties[_inhalt1]" value="Nr. 24 Omas Lieblingsmischung (80g)">
		  <input id="inhalt2" type="hidden" name="properties[_inhalt2]" value="Nr. 32 Alpenwind (30g)">
		  <input id="inhalt3" type="hidden" name="properties[_inhalt3]" value="Nr. 9 Ayurveda Vata (70g)">
		  <input id="inhalt4" type="hidden" name="properties[_inhalt4]" value="Teewissen kompakt">
		  <input id="inhalt5" type="hidden" name="properties[_inhalt5]" value="Teeflasche 500ml">
	`;

  //MIX mit Flasche: Weihnachten mit anderem Tee
  }else if (variant.id === 44698304774408) {
     giftContent.innerHTML = `
		  <input id="inhalt1" type="hidden" name="properties[_inhalt1]" value="Nr. 8 Weihnachtsleckerei (70g)">
		  <input id="inhalt2" type="hidden" name="properties[_inhalt2]" value="Nr. 32 Alpenwind (30g)">
		  <input id="inhalt3" type="hidden" name="properties[_inhalt3]" value="Nr. 9 Ayurveda Vata (70g)">
		  <input id="inhalt4" type="hidden" name="properties[_inhalt4]" value="Teewissen kompakt">
		  <input id="inhalt5" type="hidden" name="properties[_inhalt5]" value="Teeflasche 500ml">
	`;
  //Früchtetee mit Flasche: 39-himbeer-und-70g	24-omas-liebling-80g	40-valenciana-60g	Teewissen kompakt
  } else if ((variant.id === 44652332384520) || (variant.id === 44698304676104) || (variant.id === 44698329907464) || (variant.id === 44698322731272)) {
    giftContent.innerHTML = `
		  <input id="inhalt1" type="hidden" name="properties[_inhalt1]" value="Nr. 39 Himbeer & Mehr (70g)">
		  <input id="inhalt2" type="hidden" name="properties[_inhalt2]" value="Nr. 24 Omas Lieblingsmischung (80g)">
		  <input id="inhalt3" type="hidden" name="properties[_inhalt3]" value="Nr. 40 La Valenciana (60g)">
		  <input id="inhalt4" type="hidden" name="properties[_inhalt4]" value="Teewissen kompakt">
		  <input id="inhalt5" type="hidden" name="properties[_inhalt5]" value="Teeflasche 500ml">
	`;
  //Kräutertee mit Flasche: 32-alpenwind-30g	9-ayuverda-vata-70g	3-Aphroditee-60g	Teewissen kompakt
  } else if ((variant.id === 44680675623176) || (variant.id === 44698304708872) || (variant.id === 44698329940232) || (variant.id === 44698322764040)) {
    giftContent.innerHTML = `
		  <input id="inhalt1" type="hidden" name="properties[_inhalt1]" value="Nr. 32 Alpenwind (30g)">
		  <input id="inhalt2" type="hidden" name="properties[_inhalt2]" value="Nr. 9 Ayurveda Vata (70g)">
		  <input id="inhalt3" type="hidden" name="properties[_inhalt3]" value="Nr. 3 Aphroditee (60g)">
		  <input id="inhalt4" type="hidden" name="properties[_inhalt4]" value="Teewissen kompakt">
		  <input id="inhalt5" type="hidden" name="properties[_inhalt5]" value="Teeflasche 500ml">
	`;
  //Grüntee mit Flasche: 14-untouched-70g	30-holy-monk-50g	34-drachentee-50g	Teewissen kompakt
  } else if ((variant.id === 44680675655944) || (variant.id === 44698304741640) || (variant.id === 44698329973000) || (variant.id === 44698322796808)) {
    giftContent.innerHTML = `
		  <input id="inhalt1" type="hidden" name="properties[_inhalt1]" value="Nr. 14 Untouched Blossom (70g)">
		  <input id="inhalt2" type="hidden" name="properties[_inhalt2]" value="Nr. 30 Holy Monk (50g)">
		  <input id="inhalt3" type="hidden" name="properties[_inhalt3]" value="Nr. 34 Dragon Well (50g)">
		  <input id="inhalt4" type="hidden" name="properties[_inhalt4]" value="Teewissen kompakt">
		  <input id="inhalt5" type="hidden" name="properties[_inhalt5]" value="Teeflasche 500ml">
	`;
  //Yoga Tee mit Flasche: 1-ingwershot-70g	9-ayuverda-vata-70g	3-Aphroditee-60g	Teewissen kompakt
  } else if ((variant.id === 44698242056456) || (variant.id === 44698304807176) || (variant.id === 44698330038536) || (variant.id === 44698322862344)) {
    giftContent.innerHTML = `
		  <input id="inhalt1" type="hidden" name="properties[_inhalt1]" value="Nr. 1 Ingwer & Kurkuma (70g)">
		  <input id="inhalt2" type="hidden" name="properties[_inhalt2]" value="Nr. 9 Ayurveda Vata (70g)">
		  <input id="inhalt3" type="hidden" name="properties[_inhalt3]" value="Nr. 3 Aphroditee (60g)">
		  <input id="inhalt4" type="hidden" name="properties[_inhalt4]" value="Teewissen kompakt">
		  <input id="inhalt5" type="hidden" name="properties[_inhalt5]" value="Teeflasche 500ml">
	`;
  } else {
    
  } 
}

// Event Listener für Variantenänderungen
document.addEventListener('variant:changed', function(event) {
  let variant = event.detail.variant;
  updateGiftContent(variant);
});

// Initial einen variant:changed Event auslösen
document.addEventListener('DOMContentLoaded', function() {
  const variantInput = document.querySelector('input[name="id"]');
  if (variantInput) {
    const variantId = parseInt(variantInput.value);
    // Simuliere einen variant:changed Event
    const event = new CustomEvent('variant:changed', {
      detail: {
        variant: {
          id: variantId
        }
      }
    });
    document.dispatchEvent(event);
  }
});

/**
 * ------------------------------------------------------------------------------------------------------------
 * BR: EU LEGAL GUARANTEE NOTICE — KEYBOARD AND FALLBACK
 * ------------------------------------------------------------------------------------------------------------
 *
 * snippets/br-legal-guarantee.liquid opens the official EU notice in a native [popover], which needs no JavaScript.
 * This block only covers what the popover cannot do on its own in this theme:
 *
 * - Escape: inside the cart drawer, Focal's focus trap listens for Escape on `document` in the capture phase,
 *   closes the drawer and cancels the key, so the notice stayed open on top of the page with no drawer behind it.
 *   This listener runs one step earlier (capture on `window`): while a notice is open, Escape closes just the
 *   notice and the drawer stays open. The keyup of the same keystroke is swallowed too.
 * - Tab: the popover is not modal, so Tab moves on from its last link to the checkout button hidden behind it.
 *   When focus leaves an open notice, the notice closes.
 * - Browsers without the Popover API (Safari < 17, Firefox < 125): the CSS hides the notice there, so it cannot
 *   push the checkout button out of the drawer, and the button opens the official notice file in a new tab.
 */
(() => {
  if (!HTMLElement.prototype.hasOwnProperty('popover')) {
    document.addEventListener('click', (event) => {
      const button = event.target instanceof Element && event.target.closest('.br-legal-guarantee__open');
      const notice = button && document.getElementById(button.getAttribute('popovertarget'));
      const file = notice && notice.querySelector('.br-legal-guarantee-popover__notice');

      if (file) {
        window.open(file.src, '_blank', 'noopener');
      }
    });

    return;
  }

  let swallowKeyup = false;

  window.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') {
      return;
    }

    const openNotice = document.querySelector('.br-legal-guarantee-popover:popover-open');

    if (!openNotice) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    openNotice.hidePopover();
    swallowKeyup = true;
  }, true);

  window.addEventListener('keyup', (event) => {
    if (event.key === 'Escape' && swallowKeyup) {
      event.stopImmediatePropagation();
      swallowKeyup = false;
    }
  }, true);

  document.addEventListener('focusin', (event) => {
    const openNotice = document.querySelector('.br-legal-guarantee-popover:popover-open');

    if (openNotice && !openNotice.contains(event.target)) {
      openNotice.hidePopover();
    }
  });
})();